
document.addEventListener('DOMContentLoaded', function() {
  const updateRegularPrice = (value) => {
    var priceInputs = document.querySelectorAll("[data-product-price]")
    priceInputs.forEach(function(priceInput) {
      const currentPriceDOM = priceInput.querySelector('.pl-pdp-current-price');
      const currentPrice = currentPriceDOM.textContent
      const newPrice = String(value)
      if (currentPrice !== newPrice) {
       currentPriceDOM.textContent = value
      }
    })
  }
  const updateCompareAtPrice = (value) => {
    var priceInputs = document.querySelectorAll("[data-product-price]")
    priceInputs.forEach(function(priceInput) {
      const compareAtPriceDom = priceInput.querySelector('.pl-pdp-compare-at-price');
      if (compareAtPriceDom != null) {
        const currentPrice = compareAtPriceDom.textContent
        const newPrice = String(value)
        if (currentPrice !== newPrice) {
        compareAtPriceDom.textContent = value
        }
      }
    })
  }

  document.addEventListener("sabah:selected-variant", (e) => updateRegularPrice(formatMoney(e.detail.price, '${{amount_no_decimals}}')));
  document.addEventListener("sabah:selected-variant", (e) => updateCompareAtPrice(formatMoney(e.detail.compare_at_price, '${{amount_no_decimals}}')));
})
